import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { WhatsAppOutlined, MailOutlined, CopyOutlined, ShareAltOutlined } from '@ant-design/icons';
import { notificationGibobs } from '../HerramientasVenta/reusableItems';
import {
	AMIGOBS_CHANNELS,
	amigobsMailUrl,
	amigobsWhatsappUrl,
	buildAmigobsLink,
	copyTextToClipboard
} from './amigobsLink';

const buttonStyle = { width: '100%', height: 40, marginTop: 12 };

// Replaces RWebShare for Amigobs: each channel shares its own link with its utm_content.
export const AmigobsShareModal = ({ open, onClose, dataProfile, text, title = undefined, onShare = undefined }) => {
	const { t } = useTranslation();
	const shareTitle = title || t('amigobs.shareLink');

	const share = (channel) => {
		const link = buildAmigobsLink(dataProfile, channel);
		if (!link) return;
		onShare && onShare(channel);

		if (channel === AMIGOBS_CHANNELS.WHATSAPP) {
			window.open(amigobsWhatsappUrl(text, link), '_blank');
		} else if (channel === AMIGOBS_CHANNELS.EMAIL) {
			window.open(amigobsMailUrl(shareTitle, text, link), '_self');
		} else if (channel === AMIGOBS_CHANNELS.COPY_LINK) {
			copyTextToClipboard(link);
			notificationGibobs('success', t('form.codeCopiedSuccessfully'));
		} else if (channel === AMIGOBS_CHANNELS.NATIVE_SHARE) {
			navigator
				.share({ text, url: link, title: shareTitle })
				.catch((error) => console.error('Error al compartir enlace', error));
		}
		onClose();
	};

	// Portal events bubble through the React tree: keep them from reaching clickable parents
	return (
		<span onClick={(e) => e.stopPropagation()}>
			<Modal
				className="ModalCommonSmallNoButtons"
				open={open}
				onCancel={onClose}
				footer={null}
				title={shareTitle}
				destroyOnClose
				centered>
				<Button
					className="button-primari-gibobs"
					type="primary"
					style={buttonStyle}
					icon={<WhatsAppOutlined />}
					onClick={() => share(AMIGOBS_CHANNELS.WHATSAPP)}>
					WhatsApp
				</Button>
				<Button
					className="button-secundary-gibobs"
					style={buttonStyle}
					icon={<MailOutlined />}
					onClick={() => share(AMIGOBS_CHANNELS.EMAIL)}>
					Email
				</Button>
				<Button
					className="button-secundary-gibobs"
					style={buttonStyle}
					icon={<CopyOutlined />}
					onClick={() => share(AMIGOBS_CHANNELS.COPY_LINK)}>
					{t('init.copyLink')}
				</Button>
				{typeof navigator !== 'undefined' && navigator.share && (
					<Button
						className="button-secundary-gibobs"
						style={buttonStyle}
						icon={<ShareAltOutlined />}
						onClick={() => share(AMIGOBS_CHANNELS.NATIVE_SHARE)}>
						{t('amigobs.shareOtherApps', 'Otras apps')}
					</Button>
				)}
			</Modal>
		</span>
	);
};

// Drop-in wrapper with the same shape as RWebShare's children usage.
const AmigobsShare = ({ children, dataProfile, text, title, onClick }) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<span
				onClick={(e) => {
					e.stopPropagation();
					onClick && onClick();
					setOpen(true);
				}}>
				{children}
			</span>
			<AmigobsShareModal
				open={open}
				onClose={() => setOpen(false)}
				dataProfile={dataProfile}
				text={text}
				title={title}
			/>
		</>
	);
};

export default AmigobsShare;
